import { XCircle } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { updateRole } from "../../slices/authSlice";
import { useRoles } from "../../hooks/useRoles";
import type { Role } from "../../types/auth";
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

const SwitchProfileModal: React.FC<Props> = ({
    isOpen,
    onClose,
}) => {
    const { roles } = useRoles();
    const userProfile = useAppSelector((state) => state.auth.user);
    const activeRole = useAppSelector((state) => state.auth).activeRole;
    const allroles = activeRole === "Admin" ? roles?.map((role: Role) => role.name) : userProfile?.roles;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    if(!isOpen) return null;

    const modalContent = (
        <div className="modal" onClick={onClose}>
            <div className="modal-body p-4 flex flex-col gap-4" onClick={(e) => e.stopPropagation()}>
                <div className="flex justify-between w-full">
                    <div>
                        <span className="text-xl font-bold">Switch Profile</span>
                    </div>

                    <XCircle 
                        onClick={onClose}
                        color="red"
                    />
                </div>

                <div className="mt-3 text-left">
                    <span className="text-left">Your available profiles:</span>
                    <div className="flex flex-col gap-2 my-4">
                        {
                            allroles?.map((role: string) => {
                                const isCurrentRole = role === activeRole;
                                return (
                                <div 
                                    onClick={() => {
                                        if(role === activeRole) {
                                            console.log("Already assigned this role") 
                                        } else {
                                            dispatch(updateRole({ value: role }))
                                            console.log("Active role:", role);
                                            // Navigate directly to the new role's dashboard
                                            navigate(`/${role.toLowerCase()}`, { replace: true });
                                            onClose();
                                        }   
                                    }}
                                    className={`flex justify-between hover:shadow-md cursor-pointer items-center px-4 py-2 border text-primary border-primary rounded-md`}>

                                        {role}

                                    {isCurrentRole && (
                                        <div className="bg-blue-100 font-bold text-primary rounded-xl px-4 py-1">
                                            Active Profile
                                        </div>
                                    )}
                                </div>
                            )})
                        }
                    </div>
                </div>
            </div>
        </div>
    );

    return createPortal(modalContent, document.body);
}
 
export default SwitchProfileModal;